<template>
    <div class="story-maker-sticker story-maker-sticker-countdown" :class="{edit: isEditing}" @click="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')" @click="changeColor">
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <div 
            class="sticker sticker-countdown"
            :class="[`color-${models.color.slice(1).toUpperCase()}`]"
            :style="{ 
                backgroundColor: models.color,
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
            }"
        >
            <div class="countdown-header" v-if="isEditing || models.name">
                <textarea 
                    cols="20" 
                    rows="2" 
                    wrap="hard" 
                    maxlength="100"
                    :placeholder="$t('dash.post-creator.story.countdown-name')"
                    v-model="models.name" 
                    :readonly="!isEditing" 
                    @input="autoGrow" 
                    ref="input_countdown_name"
                ></textarea>
            </div>
            <div class="countdown" @click.stop="clickDate">
                <template v-if="!this.dataCountdown || parseInt(this.dataCountdown.months) > 0">
                    <div class="data months">
                        <div class="values">
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.months[0] : 0 }}</div>
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.months[1] : 0 }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-months') }}</p>
                    </div>
                    <div class="separator">:</div>
                </template>
                <template v-if="!this.dataCountdown || parseInt(this.dataCountdown.days) > 0 || parseInt(this.dataCountdown.months) > 0">
                    <div class="data days">
                        <div class="values">
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.days[0] : 0 }}</div>
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.days[1] : 0 }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-days') }}</p>
                    </div>
                    <div class="separator">:</div>
                </template>
                <div class="data hours">
                    <div class="values">
                        <div class="value">{{ this.dataCountdown ? this.dataCountdown.hours[0] : 0 }}</div>
                        <div class="value">{{ this.dataCountdown ? this.dataCountdown.hours[1] : 0 }}</div>
                    </div>
                    <p>{{ $t('dash.post-creator.story.countdown-hours') }}</p>
                </div>

                <template v-if="this.dataCountdown && parseInt(this.dataCountdown.months) <= 0">
                    <div class="separator">:</div>
                    <div class="data hours">
                        <div class="values">
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.minutes[0] : 0 }}</div>
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.minutes[1] : 0 }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-minutes') }}</p>
                    </div>
                </template>
                <template v-if="this.dataCountdown && parseInt(this.dataCountdown.days) <= 0 && parseInt(this.dataCountdown.months) <= 0">
                    <div class="separator">:</div>
                    <div class="data hours">
                        <div class="values">
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.secondes[0] : 0 }}</div>
                            <div class="value">{{ this.dataCountdown ? this.dataCountdown.secondes[1] : 0 }}</div>
                        </div>
                        <p>{{ $t('dash.post-creator.story.countdown-seconds') }}</p>
                    </div>
                </template>
            </div>
          
        </div>


        <div v-if="showPicker && isEditing" class="menu" ref="menu_countdown">
            <div class="header-menu">
                <p>{{ $t('dash.post-creator.story.countdown-choose-date') }}</p>
            </div>
            <div class="content">
                
                <div class="form">
                    <div class="container-input">
                        <div class="input input-date">
                            <i class="fa-regular fa-calendar"></i>
                            <p>{{ formatInputDatePicker }}</p>
                            <input type="date" v-model="models.date" @click="(e)=>e.target.showPicker()" :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')">
                        </div>
                        <template v-if="models.hours !== false && models.minutes !== false">
                            <p class="separator">{{ $t('dash.post-creator.story.countdown-at') }}</p>
                            <div class="input input-time">
                                <input placeholder="00" v-model="models.hours" maxlength="2">
                            </div>
                            <p class="separator">:</p>
                            <div class="input input-time">
                                <input placeholder="00" v-model="models.minutes" maxlength="2">
                            </div>
                        </template>
                    </div>
                    <div class="allDay">
                        <label for="allDay">{{ $t('dash.post-creator.story.countdown-all-day') }}</label>
                        <ComponentSwitch :value="models.hours === false || models.minutes === false" :onChange="changeSwitchAllDay" :id="'switch-countdown-menu'" size="m"/>
                    </div>


                </div>
            
            </div>
            
        </div>

    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import { formatDateToYYYYMMDD, parseYYYYMMDD } from '@/utils/Date.js'

    const colorsHeader = ["#FFFFFF","#0C0F14", "#FF0466", "#E70AC9", "#8037FC", "#FE700A", "#00D357", "#0D97FD"]
    
    export default {
        components: {
            ComponentSwitch
        },

        props: {
            id: Number | String,
            isEditing: Boolean,
            emoji: String,
            name: String,
            date: String,
            hours: String|Boolean,
            minutes: String|Boolean,
            color: String,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },

        mounted () {
            console.log('clem23 mounted')
            if (this.setCbClick) this.setCbClick(this.clickSticker);
            EventBus.$on('storyMaker-confirmEditingSticker', this.saveCurrentState);

            this.$nextTick(()=> {
                if(this.isEditing) this.focusAtEnd()
            })


            this.models.date = this.date

            if (!this.date) {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrow.setHours(0, 0, 0, 0);
                this.models.date = formatDateToYYYYMMDD(tomorrow)
            }

            this.models.hours = isNaN(this.hours) || this.hours === false ? false : String(this.hours)
            this.models.minutes = isNaN(this.minutes) || this.minutes === false ? false : String(this.minutes)

        },

        data() {
            return {
                models: {
                    name : '',
                    color: '',
                    date : '2025-05-29',
                    hours: false,
                    minutes: false,
                },

                showPicker : false
            }
        },

        methods: {
            clickSticker() {
                if (this.isEditing) return 
                this.setCover(true)
                this.$nextTick(()=> {
                    this.$emit('updateSticker',this.id , {
                        isEditing: true
                    })   
                })
            },

            saveCurrentState() {
                if (!this.isEditing) return;
                if (!this.models.name) this.models.name = this.$t('dash.post-creator.story.countdown-default');
                this.$emit('updateSticker', this.id, {
                    isEditing: false,
                    data: {
                        name: this.models.name,
                        color: this.models.color,
                        date: this.models.date,
                        hours: this.models.hours === false ? false : parseInt(this.models.hours),
                        minutes: this.models.minutes === false ? false : parseInt(this.models.minutes),
                    },
                });
                if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
                this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
            },

            finish(event) {
                console.log('clem23 finish')
                if (this.isCover && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                    if (this.showPicker) {
                        this.showPicker = false;
                        return;
                    }
                    this.saveCurrentState();
                }
            },

            changeColor() {
                const index = colorsHeader.findIndex((color)=> color == this.models.color)
                this.models.color = colorsHeader[(index+1)%colorsHeader.length]                
            },

            focusAtEnd() {

                try {
                    const element = this.$refs[`input_countdown_name`]

                    const range = document.createRange();
                    const selection = window.getSelection();

                    range.selectNodeContents(element);
                    range.collapse(false);

                    selection.removeAllRanges();
                    selection.addRange(range);

                    // Donnez le focus à l'élément
                    element.focus();
                } catch (error) {
                    
                }

            },

            clickDate() {
                
                if(this.isEditing) {
                    this.showPicker = true
                }
            },

            changeSwitchAllDay(value) {
                console.log('changeSwitchAllDay', value)
                if (value) {
                    this.models.hours = false
                    this.models.minutes = false
                }else{
                    const now = new Date();
                    now.setMinutes(now.getMinutes() + 10);
                    this.models.hours = now.getHours().toString()
                    this.models.minutes = now.getMinutes().toString()
                }
            },

            verifData() {
                if (this.models.hours !== false && this.models.minutes !== false) {
                    
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    if (parseYYYYMMDD(this.models.date) < today) {
                        this.models.date = formatDateToYYYYMMDD(today)
                    }

                    let h = parseInt(this.models.hours, 10);
                    let m = parseInt(this.models.minutes, 10);

                    h = Math.min(23, h)
                    m = Math.min(59, m)

                    const dateNow = new Date()
                    const date = parseYYYYMMDD(this.models.date)
                    date.setHours(h)
                    date.setMinutes(m)

                    if (date < dateNow) {
                        dateNow.setMinutes(dateNow.getMinutes() + 10);
                        h = dateNow.getHours()
                        m = dateNow.getMinutes()
                    }
                
                    // Formatage sur 2 chiffres
                    this.models.hours = h.toString().padStart(2, '0');
                    this.models.minutes = m.toString().padStart(2, '0');
                }else{
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    tomorrow.setHours(0, 0, 0, 0);
            
                    if (parseYYYYMMDD(this.models.date) < tomorrow) {
                        this.models.date = formatDateToYYYYMMDD(tomorrow)
                    }
                }
            
            },

            autoGrow() {
            
                let element = this.$refs.input_countdown_name
                console.log("autoGrow",element)
            
                element.style.height = "5px";
                element.style.height = (element.scrollHeight) + "px";
            }
        },

        computed: {
            dataCountdown() {
                if (this.models.date) {
                    const futureDate = parseYYYYMMDD(this.models.date)
                    if (this.models.hours === false || this.models.minutes === false) {
                        // futureDate.setDate(futureDate.getDate() + 1);
                        futureDate.setHours(0);
                        futureDate.setMinutes(0);
                        futureDate.setSeconds(0);
                        futureDate.setMilliseconds(0);
                    }else{
                        futureDate.setHours(this.models.hours)
                        futureDate.setMinutes(this.models.minutes)
                        futureDate.setSeconds(0);
                        futureDate.setMilliseconds(0);
                    }
                   
                    var distance = futureDate.getTime() - new Date().getTime();
                 
                    const timeSeconde = 1000
                    const timeMinute = timeSeconde * 60
                    const timeHour = timeMinute * 60
                    const timeDay = timeHour * 24
                    const timeMonth = timeDay * 30

                    let months = Math.floor(distance/timeMonth)
                    distance -= timeMonth * months

                    var days = Math.floor(distance/timeDay)
                    distance -= timeDay * days

                    var hours = Math.floor(distance/timeHour)
                    distance -= timeHour * hours

                    var minutes = Math.floor(distance/timeMinute)
                    distance -= timeMinute * minutes

                    var secondes = Math.floor(distance/timeSeconde)

                    return {
                        months: months.toString().padStart(2, '0'),//
                        days: days.toString().padStart(2, '0'),//
                        hours: hours.toString().padStart(2, '0'),//
                        minutes: minutes.toString().padStart(2, '0'),// X
                        secondes: secondes.toString().padStart(2, '0'), // X
                    }
                }
               
                return false
            },
            formatInputDatePicker() {
                if(!this.models.date) return '';
                let dateNow = new Date()
                let dateFuture = parseYYYYMMDD(this.models.date)
        
                if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                    if (Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24)) < 7) {
                        if (dateFuture.getDay() === dateNow.getDay()) return this.$t('dash.post-creator.render.today')
                        if (dateFuture.getDay() === dateNow.getDay()+1) return this.$t('dash.post-creator.render.tomorrow')
                        return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long' });
                    }
                    return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric', month: 'long' });
                }
                return dateFuture.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'long', year: 'numeric' });
            },
        },

        beforeDestroy() {
            EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
        },

        watch: {
            name: {
                handler(newValue) {
                    this.models.name = newValue
                },
                immediate: true
            },
            color: {
                handler(newValue) {
                    this.models.color = newValue
                },
                immediate: true
            },
            isEditing: {
                handler(newValue) {
                    console.log('clem23 watch', newValue, !this.isPreventCover, !this.isCover)
                    if (newValue) { 

                        if (!this.isPreventCover && !this.isCover) {
                            this.isEditing = false
                            this.clickSticker()
                        }

                        if (this.isEditing && this.name && (this.name.toLowerCase() == this.$t('dash.post-creator.story.countdown-default').toLowerCase() || this.name.toLowerCase() == 'compte à rebours')) {
                            this.models.name = ''
                        }

                        this.$nextTick(()=> {
                            if(this.isEditing) this.focusAtEnd()
                        })
                    }else{
                        this.showPicker = false
                    }
                },
                immediate: true
            },
        
            
        }
    }
</script>

<style lang="scss" scoped>

</style>